import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { store } from '@/store/store';
import { BootstrapVue, IconsPlugin,VBTogglePlugin ,CollapsePlugin } from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2';
import VConsole from "vconsole";

// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "sweetalert2/dist/sweetalert2.min.css";
import javaScriptCallback from "@/assets/ts/jsNextInterface.js";
Vue.prototype.$event = new Vue();
axios.interceptors.request.use(
  (config) => {
    store.state.isLoading = true;
    return config;
  },
  (error) => {
    store.state.isLoading = false;
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (config) => {
    store.state.isLoading = false;
    return config;
  },
  (error) => {
    store.state.isLoading = false;
    return Promise.reject(error);
  }
);
if (process.env.VUE_APP_VCONSOLE_FLAG == "true") {
  const vconsole = new VConsole();
  Vue.use(vconsole);
}
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$callback = javaScriptCallback;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueSweetalert2);
Vue.use(VBTogglePlugin);
Vue.use(CollapsePlugin);
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
Vue.prototype.$http.defaults.headers.common["Content-Type"] =
  "application/json";
